import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React from 'react';
import { ListBoxSection, Header } from 'react-aria-components';

const header = "_header_139rn_1";
const section = "_section_139rn_6";
const styles = {
	header: header,
	section: section
};

const SelectGroup = (_a) => {
  var { children, className, label } = _a, otherProps = __rest(_a, ["children", "className", "label"]);
  return React.createElement(
    ListBoxSection,
    Object.assign({ className: clsx(className, styles.section) }, otherProps, { "data-zds": true }),
    React.createElement(Header, { className: styles.header, "data-zds": true }, label),
    children
  );
};

export { SelectGroup };
//# sourceMappingURL=SelectGroup.es.js.map
